module.exports = __webpack_public_path__ + "static/media/caja2.860aa66f.jpg";